import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, LineReveal } from "./motion/Reveal";
import { scrollToId } from "@/lib/scroll";
import { WHATSAPP_URL } from "@/lib/scroll";

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["20%", "-20%"]);

  return (
    <section ref={ref} data-testid="final-cta-section" className="relative bg-charcoal text-ivory py-32 lg:py-48 overflow-hidden">
      <motion.span style={{ y }} aria-hidden className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-serif italic text-[34vw] leading-none text-ivory/[0.035] select-none pointer-events-none">A</motion.span>
      <div className="container-x relative text-center flex flex-col items-center">
        <Reveal><p className="eyebrow !text-gold/80 mb-8">Let's Build Something Beautiful</p></Reveal>
        <LineReveal inView as="h2" lines={["Ready to Build", <>Something <span className="italic text-ivory/60">Worth</span></>, "Exploring?"]} className="display text-5xl sm:text-6xl lg:text-8xl text-ivory" />
        <Reveal delay={0.3} className="text-base sm:text-lg text-ivory/60 font-light max-w-xl mt-10 leading-relaxed">Tell us about your business, your vision, and the experience you want your customers to have.</Reveal>
        <Reveal delay={0.4} className="mt-12 flex flex-wrap justify-center gap-4">
          <button data-testid="final-cta-start" onClick={() => scrollToId("contact")} className="btn btn-light"><span>Start Your Project</span></button>
          <a data-testid="final-cta-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn btn-outline-light"><span>Talk to Amara Studios</span></a>
        </Reveal>
      </div>
    </section>
  );
};
